import styled from "@emotion/styled";

export const ApplicationWrapper = styled.div`
	display: flex;
	position: relative;
	min-height: 100vh;
`;
